<template>
<a-row>
  <a-row>
    <a>
      <i><svg t="1565853690623" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13161" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="35"><path d="M768 105.6H256c-35.2 0-64 28.8-64 64v713.6c-3.2 9.6 0 19.2 9.6 25.6 12.8 12.8 28.8 12.8 41.6 0L512 640l268.8 268.8c12.8 12.8 28.8 12.8 41.6 0 6.4-6.4 9.6-16 9.6-25.6V169.6c0-35.2-28.8-64-64-64z m0 707.2L534.4 576c-6.4-6.4-12.8-9.6-22.4-9.6-6.4 0-16 3.2-22.4 9.6L256 812.8v-608c0-19.2 12.8-32 32-32h448c19.2 0 32 12.8 32 32v608z" fill="#1296db" p-id="13162"></path></svg></i>
    </a>
  </a-row>
  <a-row>
  </a-row>
</a-row>
</template>

<script>

export default {
  name: 'Tags',
  props: {
    items:  {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  methods: {
    showTab: function(e, index) {
    }
  },
  created() {
  }
}
</script>

<style scoped>
</style>
